<div
        class="w-full md:w-60 relative flex self-start pt-2 pb-1 pl-5 pr-4
                    cursor-pointer overflow-hidden rounded-xl  bg-card mb-4 md:mb-0"
        matRipple
        [matMenuTriggerFor]="projectsMenu"
*ngIf="showDashboardViewMenu"

>
    <div class="flex items-center w-full justify-between">
        <div class="overflow-hidden">
            <div class="font-medium leading-6 truncate">{{selectedDashboardView}}</div>
        </div>
        <div class="flex items-center justify-center pl-2">
            <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_solid:chevron-down'"></mat-icon>
        </div>
    </div>
    <mat-menu
        #projectsMenu="matMenu"
        [xPosition]="'before'">
        <button
                mat-menu-item
                (click)="changeDashboardView('Overview')">Overview
        </button>
        <button
                mat-menu-item
                (click)="changeDashboardView('Batch')">Batch
        </button>
        <button
                mat-menu-item
                (click)="changeDashboardView('Economics')">Economics
        </button>
        <button
                mat-menu-item
                (click)="changeDashboardView('Altro')">Altro
        </button>
    </mat-menu>
</div>
<div class="flex flex-auto flex-col md:flex-row md:items-center md:justify-end">


    <mat-button-toggle-group
            value="this-week"
            class="mb-4 md:mb-0"
            (change)="changeDateFilterState($event)">
        <mat-button-toggle value="1" [checked]="selectedDateFilter === '1'">Totale</mat-button-toggle>
        <!--            <mat-button-toggle value="2" [checked]="selectedDateFilter === '2'">Oggi</mat-button-toggle>-->
        <mat-button-toggle value="2" [checked]="selectedDateFilter === '2'">Settimana</mat-button-toggle>
        <mat-button-toggle value="3" [checked]="selectedDateFilter === '3'">Mese</mat-button-toggle>


        <!--            <mat-button-toggle value="this-month">Questo mese</mat-button-toggle>-->
    </mat-button-toggle-group>
    <div class="flex w-full md:w-1/4 md:ml-4">
        <mat-form-field
                class="flex-auto">
            <!--                <mat-label>Choose a date</mat-label>-->
            <mat-date-range-input
                    [formGroup]="filterDates"

                    [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Data inizio">
                <input matEndDate formControlName="end" placeholder="Data fine">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>

</div>
